import { useQuery } from "@tanstack/react-query";

import type { GroupedTechnologies } from "app/pages/sales-intelligence/domain/technology/types/model";
import { groupTechnologiesByType } from "app/pages/sales-intelligence/domain/technology/utils/grouping";

import type { TechnologiesDescriptionDto } from "../types/dto";

import { createDescriptionQuery } from "./options";

const select = ({ technologies }: TechnologiesDescriptionDto): GroupedTechnologies =>
    groupTechnologiesByType(technologies);

type UseGroupedTechnologiesQueryOptions = {
    enabled?: boolean;
};

export default function useGroupedTechnologiesQuery({ enabled = true }: UseGroupedTechnologiesQueryOptions = {}) {
    return useQuery(
        createDescriptionQuery({
            select,
            enabled,
        }),
    );
}
